import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_RESET_DOCTOR_POTENTIAL} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const ResetDrPotentialDetails = lazy(() =>
  import('../../../screens/ResetDrPotentialDetails')
    .then(module => ({default: module.ResetDrPotentialDetails})));

const ResetDrPotentialDetailsNavigation = [
  {
    path: ROUTE_RESET_DOCTOR_POTENTIAL,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <ResetDrPotentialDetails />
      </Suspense>
    ),
  },
];

export default ResetDrPotentialDetailsNavigation;
